export interface ErrorResponse {
  message: string;
}

// Helper type guard (optional usage) to validate a dynamic object.
export function isErrorResponse(obj: unknown): obj is ErrorResponse {
  return (
    typeof obj === 'object' &&
    obj !== null &&
    'message' in obj &&
    typeof (obj as ErrorResponse).message === 'string'
  );
}
